import React, { Component } from 'react'

class BaseHEC extends Component {

}

export default BaseHEC;



/** WEBPACK FOOTER **
 ** ./app/hec/base.js
 **/